import React from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import { Button } from 'DesignSystem'

import { addAlert } from 'Store/Actions/alerts.action'

import IconSVG from 'Components/IconSVG'

import useQuery from 'Hooks/useQuery.hook'

import { createQuery } from 'Helpers/Url.helper'

export interface ButtonFederatedLoginPropsI {
  platform: 'google' | 'microsoft' | 'amazon' | 'facebook' | 'ping' | 'email'
  slug?: string | null,
  isAdmin?: boolean,
  color?: string,
  isSignUp?: boolean,
  isMigration?: boolean,
  className?: string,
  invite?: string,
  showMinimal?: boolean,
  email?: string,
  onClick?: () => void
}

const ButtonFederatedLogin = (props: ButtonFederatedLoginPropsI) => {
  const { platform, isSignUp = false, isMigration = false, className, slug, isAdmin = false, invite, showMinimal = false, email, onClick } = props
  const intl = useIntl()
  const dispatch = useDispatch()
  const urlQuery = useQuery()
  const query = createQuery()
  const parametersTracking = urlQuery.findAll()

  const isPingWithoutSlug = platform === 'ping' && !slug

  if (slug) query.addParams('slug', slug)
  if (isAdmin) query.addParams('admin', 'true')
  if (invite) query.addParams('invite', invite)
  if (urlQuery.get('price_pre_chosen')) query.addParams('price_pre_chosen', urlQuery.get('price_pre_chosen') as string)
  if (parametersTracking.length) parametersTracking.forEach(({ key, value }) => query.addParams(key, value))
  if (platform === 'ping' && email) query.addParams('email', email)

  const link = `${process.env.REACT_APP_API_URL}login/federated/${platform}${query.getValue()}`

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (platform === 'email') {
      event.preventDefault()
      onClick?.()
      return
    }
    if (isPingWithoutSlug && !email) {
      event.preventDefault()
      dispatch(addAlert({ title: intl.formatMessage({ id: 'Digite seu email' }), type: 'error' }))
    } else {
      window.location.href = link
    }
  }

  const initialText = (() => {
    switch (true) {
      case isSignUp:
        return intl.formatMessage({ id: 'Registrar com' })
      case isMigration:
        return intl.formatMessage({ id: 'Migrar para' })
      default:
        return intl.formatMessage({ id: 'Logar com' })
    }
  })()

  return (
    <Button className={className} color="white" size='sm' onClick={handleClick}>
        <IconSVG icon={platform} />
        {!showMinimal && platform && `${initialText} ${intl.formatMessage({ id: platform })}`}
    </Button>
  )
}

export default ButtonFederatedLogin
